import { GET_INVESTMENTS } from '../actionTypes'
import { Investment } from '../reducers/investment'

export const getInvestmentAction = (investments: Investment[]) => ({ type: GET_INVESTMENTS, payload: investments })
